import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IPolicy, PolicyType } from '../_models/policy.model';
import { PolicyService } from '../_services/policy.service';
import { SeoService } from '../../_shared/_services/seo.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-terms-of-service',
    templateUrl: './terms-of-service.component.html',
    styleUrls: ['./terms-of-service.component.scss'],
    imports: [AsyncPipe]
})
export class TermsOfServiceComponent implements OnInit {
  private readonly policyService = inject(PolicyService);
  private readonly seoService = inject(SeoService);

  public policies$!: Observable<Array<IPolicy>>;
  public terms: PolicyType = PolicyType.TERMS_OF_SERVICE;

  ngOnInit(): void {
    this.seoService.createCanonicalUrl('https://mypoolhut.com/policy/terms-of-service');
    this.policies$ = this.policyService.policies$;
    this.policyService.loadPolicies();
  }

}
